/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { MembershipTypesEnumType } from './MembershipTypesEnum'
import { SubscriptionTypeEnumType } from './SubscriptionTypeEnum'
import { RootStoreType } from './index'

/**
 * MembershipBase
 * auto generated base class for the model MembershipModel.
 */
export const MembershipModelBase = ModelBase.named('Membership')
  .props({
    __typename: types.optional(types.literal('Membership'), 'Membership'),
    _id: types.identifier,
    appleSubscriptionId: types.union(types.undefined, types.null, types.string),
    cancelAt: types.union(types.undefined, types.null, types.string),
    cancelAtPeriodEnd: types.union(types.undefined, types.boolean),
    canceledAt: types.union(types.undefined, types.null, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    defaultPaymentMethod: types.union(types.undefined, types.null, types.string),
    downgradeTo: types.union(types.undefined, types.null, MembershipTypesEnumType),
    endOfPeriod: types.union(types.undefined, types.null, types.string),
    /** This flag is used to track the number of failed payment attempts for managing mail notifications This is reset to 0 when a payment is successful */
    failedPaymentAttempts: types.union(types.undefined, types.null, types.number),
    firstPaymentFailedDate: types.union(types.undefined, types.null, types.string),
    /** This flag is used in case the very first payment intent fails If hasPaidBefore is false, and the first payment fails (subscription creation), we just cancel that incomplete subscription */
    hasPaidBefore: types.union(types.undefined, types.null, types.boolean),
    membershipTypeId: types.union(types.undefined, types.frozen()),
    pendingDowngrade: types.union(types.undefined, types.null, types.boolean),
    startOfPeriod: types.union(types.undefined, types.string),
    status: types.union(types.undefined, types.string),
    stripeSubscriptionId: types.union(types.undefined, types.string),
    subscriptionCreatedAt: types.union(types.undefined, types.string),
    subscriptionType: types.union(types.undefined, types.null, SubscriptionTypeEnumType),
    type: types.union(types.undefined, types.null, MembershipTypesEnumType),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class MembershipModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get appleSubscriptionId() {
    return this.__attr('appleSubscriptionId')
  }
  get cancelAt() {
    return this.__attr('cancelAt')
  }
  get cancelAtPeriodEnd() {
    return this.__attr('cancelAtPeriodEnd')
  }
  get canceledAt() {
    return this.__attr('canceledAt')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get defaultPaymentMethod() {
    return this.__attr('defaultPaymentMethod')
  }
  get downgradeTo() {
    return this.__attr('downgradeTo')
  }
  get endOfPeriod() {
    return this.__attr('endOfPeriod')
  }
  get failedPaymentAttempts() {
    return this.__attr('failedPaymentAttempts')
  }
  get firstPaymentFailedDate() {
    return this.__attr('firstPaymentFailedDate')
  }
  get hasPaidBefore() {
    return this.__attr('hasPaidBefore')
  }
  get membershipTypeId() {
    return this.__attr('membershipTypeId')
  }
  get pendingDowngrade() {
    return this.__attr('pendingDowngrade')
  }
  get startOfPeriod() {
    return this.__attr('startOfPeriod')
  }
  get status() {
    return this.__attr('status')
  }
  get stripeSubscriptionId() {
    return this.__attr('stripeSubscriptionId')
  }
  get subscriptionCreatedAt() {
    return this.__attr('subscriptionCreatedAt')
  }
  get subscriptionType() {
    return this.__attr('subscriptionType')
  }
  get type() {
    return this.__attr('type')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
}
export function selectFromMembership() {
  return new MembershipModelSelector()
}

export const membershipModelPrimitives =
  selectFromMembership()._id.appleSubscriptionId.cancelAt.cancelAtPeriodEnd.canceledAt.createdAt.defaultPaymentMethod
    .downgradeTo.endOfPeriod.failedPaymentAttempts.firstPaymentFailedDate.hasPaidBefore.membershipTypeId
    .pendingDowngrade.startOfPeriod.status.stripeSubscriptionId.subscriptionCreatedAt.subscriptionType.type.updatedAt
    .userId
